<template>
  <div>
    <v-row>
      <v-col cols="12" style="padding:0 40px 40px">
        <v-row v-if="[USER_TYPES.admin].includes(userType)">
          <v-col cols="12">
            <div style="border-bottom: 1px dashed grey;" class="pa-3 mt-5">
              <v-row>
                <v-col cols="12" md="6" class="d-flex">
                  <div class="ml-1 pt-2">نماینده:</div>
                  <v-combobox v-if="!agent" clearable outlined return-object v-model="selectedAgent" single-line item-text="businessName" item-value="id" style="" :items="agents" dense></v-combobox>
                  <span v-else class="grey--text pt-2">{{ agent.businessName }}</span>
                </v-col>
                <v-col cols="12" md="6" class="d-flex">
                  <div class="ml-1 pt-2">مشتری:</div>
                  <div class="grey--text pt-2">
                    <small>{{ selectedMember ? selectedMember.fullName : "مشتری تعیین نشده است" }}</small>
                  </div>
                  <v-btn v-if="!member" color="secondary" class="mt-2 mx-1" small @click="() => { dialogMembersSelector = true }">
                    انتخاب مشتری
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="selectedMember && [USER_TYPES.agent].includes(userType)">
          <v-col cols="12" md="12" class="">
            <v-card color="#eee" elevation="0" class="pa-2 my-2 text-center">
              <div class="secondary--text mb-2" style="font-size: 14pt;">
                {{ selectedMember.fullName }}
              </div>
              <div class="grey--text">کد ملی:</div>
              <div class="secondary--text" style="font-size: 14pt;">
                {{ selectedMember.nationalCode }}
              </div>
              <v-btn icon color="red" style="position: absolute;top: 10px;left: 10px" @click="selectedMember = null">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3"> </v-col>
          <v-col cols="12" md="6">
            <date-navigator v-if="!hideDateRange" v-model="dateRange" :options="{ rangeMode: true, defaultEmpty: true }">
              <div class="text-center">
                <v-btn v-if="!hideDateRange" small color="primary" dark class="mx-1" @click="loadData">
                  دریافت اطلاعات
                </v-btn>
              </div>
            </date-navigator>
          </v-col>
          <v-col cols="12" md="3" class="d-flex align-center justify-end">
            <v-btn v-if="[USER_TYPES.admin].includes(userType)" small color="primary" class="mx-1" @click="add">
              <v-icon class="mr-1">mdi-plus</v-icon>
              افزودن صورتحساب
            </v-btn>
            <v-btn v-if="hideDateRange" small color="primary" :loading="loading" fab outlined class="mx-1" @click="loadData">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <export-excel :ignoreCheckPermission="true" :items="items" :headers="headers" :fileName="excelFileName">
            </export-excel>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="8">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
          </v-col>
          <v-col cols="12">
            <v-data-table dense :headers="headers" :loading="loading" :items="items" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
              <template v-slot:item.member.nationalCode="{ item }">
                <div>
                  {{ item.member.fullName }}
                </div>
                <div>
                  <small>کد ملی: </small><small class="grey--text">{{
                    item.member.nationalCode
                  }}</small>
                </div>
                <div class="d-flex">
                  <small>شماره تماس: </small><small class="grey--text pr-1">
                    {{ item.member.mobile }}</small>
                </div>
              </template>
              <template v-slot:item.amount="{ item }">
                {{ item.amount.toString().toPriceFormat() }}
                <small>تومان</small>
              </template>
              <template v-slot:item.createAt_Persian="{ item }">
                <div class="ltr">
                  {{
                    `${item.createAt_Persian.date} ${item.createAt_Persian.time}`
                  }}
                </div>
              </template>
              <template v-slot:item.checkoutType="{ item }">
                {{
                  item.checkoutType === 2
                    ? "کیف پول"
                    : item.memberPurchase
                      ? "پرداخت آنلاین"
                      : item.checkoutType === 3 && !item.memberPurchase
                        ? "در انتظار پرداخت آنلاین"
                        : "پرداخت نشده"
                }}
              </template>
              <template v-slot:item.memberPurchase="{ item }">
                <div v-if="![USER_TYPES.member].includes(userType)" class="text-right">
                  <small>کارمزد:</small>
                  <small class="grey--text mr-1">{{ item.commission.toString().toPriceFormat() }} تومان</small>
                </div>
                <div class="d-flex justify-start">
                  <small>پرداختی مشتری:</small>
                  <small class="grey--text mr-1">{{ payedAmountOfFactorByCustomer(item).toString().toPriceFormat()
                  }} تومان</small>
                  <v-tooltip color="#fbe5ff" top v-if="item.memberPurchase && ![USER_TYPES.member].includes(userType)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn fab dark x-small color="secondary" outlined class="mr-2" style="transform:scale(0.7)">
                        <v-icon dark v-bind="attrs" v-on="on">
                          mdi-exclamation
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-card elevation="0" color="transparent" class="pa-3" width="300px">
                      <gateway-details class="mr-1" :data="item.memberPurchase" />
                    </v-card>
                  </v-tooltip>
                </div>
                <div class="text-right">
                  <small>سهم نماینده:</small>
                  <small class="grey--text mr-1">{{ (payedAmountOfFactorByCustomer(item) - item.commission).toString().toPriceFormat() }} تومان</small>
                </div>
                <div class="text-right" v-if="![USER_TYPES.member].includes(userType)">
                  <small>تسویه واسط:</small>
                  <small class="info--text mr-1 pointer" @click="transactions(item)">{{
                    item.sumWithdraws.toString().toPriceFormat() }} تومان</small>
                </div>
                <div class="text-center" v-if="userType === 'admin'">
                  <v-btn color="secondary" @click="transaction(item)" x-small>ثبت واریزی</v-btn>
                </div>
              </template>
              <template v-slot:item.operations="{ item }">
                <div class="text-center">
                  <v-btn class="mx-1" fab dark small color="secondary" v-if="[USER_TYPES.admin, USER_TYPES.agent].includes(userType)" @click="edit(item)">
                    <v-icon dark>
                      mdi-square-edit-outline
                    </v-icon>
                  </v-btn>
                  <v-btn class="mx-1" v-if="[USER_TYPES.admin, USER_TYPES.agent].includes(userType)" fab :disabled="true" small color="pink" @click="remove(item)">
                    <v-icon dark>
                      mdi-trash-can-outline
                    </v-icon>
                  </v-btn>
                  <v-btn class="mx-1" fab small color="info" outlined @click="print(item)" :loading="printLoadingId === item.id">
                    <v-icon dark>
                      mdi-printer-outline
                    </v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row v-if="![USER_TYPES.member].includes(userType)" style="">
          <v-col cols="12" md="6">
            <v-card elevation="1">
              <v-card-title class="justify-center grey lighten-3">
                <h3 class="">صورتحساب ها</h3>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="6" class="text-left">تعداد صورتحساب ها:</v-col>
                  <v-col cols="6" class="grey--text text-right">{{ factorsCount }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="text-left">مجموع صورتحساب ها:</v-col>
                  <v-col cols="6" class="grey--text text-right">{{ pureTotal.toString().toPriceFormat() }} تومان</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="text-left">پرداختی مشتری:</v-col>
                  <v-col cols="6" class="grey--text text-right">{{ payedByCustomer.toString().toPriceFormat() }} تومان</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="text-left">کارمزد:</v-col>
                  <v-col cols="6" class="grey--text text-right">{{ commission.toString().toPriceFormat() }} تومان</v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card elevation="1">
              <v-card-title class="justify-center grey lighten-3">
                <h3 class="">تسویه حساب ها</h3>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="6" class="text-left">مجموع قابل تسویه با نماینده:</v-col>
                  <v-col cols="6" class="grey--text text-right">{{ sumCheckoutable.toString().toPriceFormat() }} تومان</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="text-left">تسویه شده:</v-col>
                  <v-col cols="6" class="grey--text text-right">{{ sumCheckouted.toString().toPriceFormat() }} تومان</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="text-left">مانده تسویه نشده:</v-col>
                  <v-col cols="6" class="grey--text text-right">{{ sumNotCheckouted.toString().toPriceFormat() }} تومان</v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div id="printHtml2" style="display: none;">
      <agent-factor-printHtml v-if="selectedItem && printToggler" @ready="printReady = true" :id="selectedItem.id" />
    </div>

    <v-dialog v-model="dialogMembersSelector" scrollable max-width="900px">
      <MembersSelector v-if="dialogMembersSelector" :selectedIds="selectedMemberIds" :emitObject="true" :multiSelect="false" @select="onMembersSelectorSelect" @close="dialogMembersSelector = false" />
    </v-dialog>

    <v-dialog v-model="dialogTransaction" scrollable max-width="925px">
      <v-card>
        <v-card-title>
          <div>
            <span class="headline">تسویه صورتحساب الکترونیکی نماینده</span>
          </div>
          <v-spacer />
          <v-btn @click="dialogTransaction = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <AgentFactorcCheckoutTransactionModify v-if="dialogTransaction" :agentFactor="selectedAgentFactor" :data="selectedTransaction" @callbck="callbck_transaction" :area="userType" />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTransactions" scrollable max-width="900px">
      <v-card>
        <v-card-title>
          <div>
            <span class="headline">تسویه صورتحساب الکترونیکی شماره {{ selectedAgentFactor ? selectedAgentFactor.code : '' }} متعلق به {{ selectedAgentFactor && selectedAgentFactor.agent ? selectedAgentFactor.agent.businessName : '' }}</span>
          </div>
          <v-spacer />
          <v-btn @click="dialogTransactions = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <AgentFactorCheckoutTransactions v-if="dialogTransactions" :area="userType" :showDateFilter="false" :agentFactorId="selectedAgentFactor.id" />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <confirm-dlg ref="confirm" />
    <div class="py-3" />
  </div>
</template>

<script>
  import api from "@/util/app-api"
  import toast from "@/util/toast"
  import { emptyId } from "@/util/emptyId"

  const USER_TYPES = {
    admin: "admin",
    agent: "agent",
    member: "member"
  }

  export default {
    name: "AgentFactorsComponent",
    props: {
      autoSubmit: { type: Boolean, default: false },
      hideDateRange: { type: Boolean, default: false },
      member: { type: Object },
      agent: { type: Object },
      userType: { type: String }
    },
    components: {
      ConfirmDlg: () => import("@/components/Confirm"),
      "date-navigator": () => import("@/components/DateNavigator"),
      // 'manage-loan': import('@/views/admin/ManageLoan.vue'),
      "agent-factor-printHtml": () => import("@/components/prints/AgentFactorPrintHtml"),
      "gateway-details": () => import("@/components/GatewayDetails"),
      "app-sms-detail": () => import("@/components/AppSmsDetails.vue"),
      AgentFactorCheckoutTransactions: () => import('@/components/forms/AgentFactorCheckoutTransactions'),
      AgentFactorcCheckoutTransactionModify: () => import("@/components/forms/AgentFactorcCheckoutTransactionModify"),
      MembersSelector: () => import("@/components/forms/MembersSelector")
    },
    data() {
      return {
        USER_TYPES: USER_TYPES,
        selectedMemberIds: [],
        dialogMembersSelector: false,
        dialogTransaction: false,
        dialogTransactions: false,
        selectedMember: null,
        selectedAgent: null,
        selectedAgentFactor: null,
        selectedTransaction: null,
        selectedItem: null,
        errorMessages: "",
        search: "",
        loading: false,
        headers: [
          {
            text: "اطلاعات مشتری",
            align: "start",
            sortable: true,
            value: "member.nationalCode",
            width: 200
          },
          {
            text: "نام مشتری",
            align: "center d-none",
            sortable: true,
            value: "member.fullName",
            width: 0
          },
          {
            text: "موبایل مشتری",
            align: "center d-none",
            sortable: true,
            value: "member.mobile",
            width: 0
          },
          {
            text: "شماره سیستمی",
            align: "center",
            sortable: true,
            value: "code"
          },
          {
            text: "شماره فرعی",
            align: "center",
            sortable: true,
            value: "userCode"
          },
          {
            text: "مبلغ صورتحساب",
            align: "center",
            sortable: true,
            value: "amount",
            width: 150
          },
          {
            text: "تاریخ صورتحساب",
            align: "center",
            sortable: true,
            value: "createAt_Persian"
          },
          {
            text: "نام پذیرنده",
            align: "center",
            sortable: true,
            value: "agent.businessName",
            width: 150
          },
          {
            text: "نحوه پرداخت",
            align: "center",
            sortable: true,
            value: "checkoutType"
          },
          {
            text: "پرداخت مشتری و تسویه واسط",
            align: "center",
            sortable: true,
            value: "memberPurchase",
            width: 250
          },
          {
            text: "عملیات ها",
            align: "center",
            sortable: false,
            value: "operations",
            width: 185
          }
        ],
        items: [],
        agents: [],
        dateRange: { start: "", end: "" },
        printReady: false,
        printToggler: false,
        printLoadingId: ""
      }
    },
    computed: {
      factorsCount() {
        return this.items.length
      },
      pureTotal() {
        return this.items.reduce(
          (accumulator, current) => accumulator + Number(current.amount),
          0
        )
      },
      payedByCustomer() {
        return this.items.reduce(
          (accumulator, current) => accumulator + Number(this.payedAmountOfFactorByCustomer(current)),
          0
        )
      },
      commission() {
        return this.items.reduce(
          (accumulator, current) => accumulator + Number(current.commission),
          0
        )
      },
      sumCheckoutable() {
        return this.items.reduce(
          (accumulator, current) =>
            accumulator + (this.payedAmountOfFactorByCustomer(current) - current.commission),
          0
        )
      },
      sumCheckouted() {
        return this.items.reduce(
          (accumulator, current) =>
            accumulator + current.sumWithdraws,
          0
        )
      },
      sumNotCheckouted() {
        return this.items.reduce(
          (accumulator, current) =>
            accumulator + (this.payedAmountOfFactorByCustomer(current) - current.sumWithdraws - current.commission),
          0
        )
      },
      excelFileName() {
        let name = "گزارش صورتحساب های صادر شده از طریق کیف پول"
        if (this.startDate)
          name += " از " + this.startDate.toString().split("T")[0]
        if (this.endDate) name += " تا " + this.endDate.toString().split("T")[0]
        name += ".xls"
        return name
      },
    },
    created() {
      if (this.autoSubmit)
        this.dateNavigatorOptions = { rangeMode: true, defaultEmpty: true }

      if (this.agent) this.selectedAgent = this.agent

      if (this.member) this.selectedMember = this.member

      if ([USER_TYPES.admin].includes(this.userType))
        this.dateRange = {
          start: new Date(
            new Date().setMonth(new Date().getMonth() - 1)
          ).toJSON(),
          end: ""
        }

      if ([USER_TYPES.agent].includes(this.userType)) {
        var index = this.headers.findIndex(x => x.value === "agent.businessName")
        if (index > -1) this.headers.splice(index, 1)
      }
    },
    mounted() {
      if (this.autoSubmit) {
        this.loadData()
      }
      if (!this.agent && [USER_TYPES.admin].includes(this.userType)) {
        this.loadAgents()
      }
    },
    methods: {
      loadData() {
        this.loading = true
        const area = USER_TYPES[this.userType]
        api
          .get(
            `${area}/AgentFactor/list?${this.selectedMember?.id ? "memberId=" + this.selectedMember?.id : ""
            }${this.selectedAgent ? "&agentId=" + this.selectedAgent.id : ""}${this.dateRange?.start ? "&start=" + this.dateRange?.start : ""
            }${this.dateRange?.end ? "&end=" + this.dateRange?.end : ""}`,
            null
          )
          .then(response => {
            this.items = response.filter(x => !x.agentId)
          })
          .catch(err => {
            toast.error(err.message)
          })
          .finally(x => {
            this.loading = false
          })
      },
      print(data) {
        this.selectedItem = null
        this.printReady = false
        this.printLoadingId = data.id
        this.printToggler = false
        setTimeout(() => {
          this.selectedItem = data
          let timer = 0
          this.printToggler = true
          let interval = setInterval(() => {
            timer++
            if (timer > 300 || this.printReady) {
              clearInterval(interval)
              this.printLoadingId = ""
            }
            if (this.printReady)
              printJS({
                printable: "printHtml2",
                type: "html",
                scanStyles: false, // If true inline styles will be removed
                targetStyles: ["*"],
                style: `
										@font-face {
											font-family:'YekanP';
											src:url(/iranyekanweb.ttf) format('truetype'),
											url(/iranyekanweb.woff) format('woff-variations'),
											url(/iranyekanweb.woff) format('woff'),
											url(/iranyekanweb.woff2) format('woff2');
											font-display:fallback
										}
										#printHtml2 {
												display: block !important;
												font-family: 'YekanP', sans-serif;
										}
									`
              })
            setTimeout(() => {
              this.printToggler = false
            }, 3000)
          }, 100)
        }, 100)
      },
      onMembersSelectorSelect(member) {
        this.selectedMember = member
        this.selectedMemberIds = [member.id]
      },
      loadAgents() {
        api
          .get("admin/agent/ListLight", null)
          .then(response => {
            this.agents = response
          })
          .catch(err => {
            toast.error(err.message)
          })
          .finally(x => {
            this.loading = false
          })
      },
      add() {
        if (!this.selectedMember) {
          toast.error("ابتدا یک مشتری انتخاب کنید")
          return
        }
        if (!this.selectedAgent) {
          toast.error("ابتدا یک نماینده انتخاب کنید")
          return
        }
        this.$emit("add", {
          id: emptyId,
          agent: this.selectedAgent,
          member: this.selectedMember,
          createAt: new Date().toJSON()
        })
      },
      edit(item) {
        this.$emit("edit", item)
      },
      remove(item) {
        this.$emit("remove", item)
      },
      setMember(member) {
        this.selectedMember = member
      },
      setDateRange(dateRange) {
        this.dateRange = dateRange
      },
      transaction(item) {
        this.selectedAgentFactor = item
        this.selectedAgentFactor.checked = true
        this.selectedTransaction = {
          id: emptyId,
          amount: this.payedAmountOfFactorByCustomer(item) - item.sumWithdraws - item.commission,
          agent: item.agent
        }
        this.dialogTransaction = true
      },
      transactions(item) {
        this.selectedAgentFactor = item
        this.dialogTransactions = true
      },
      callbck_transaction(result) {
        this.dialogTransaction = false
        if (result) {
          this.loadData()
          this.$emit("update")
        }
      },
      payedAmountOfFactorByCustomer(factor) {
        if (!factor?.checkoutType)
          return 0
        return factor?.checkoutType === 3 ? factor?.memberPurchase?.amount || 0 : factor.amount
      }
    }
  }
</script>
<style></style>
